import React, { useState, useEffect } from 'react';
import { useGQL } from 'Utils/graphql-client/use-gql/useGQL';
import { CORE_GET_FACEBOOK_CONNECT_CONFIG } from 'Utils/request/requestDictionary';
const query = `
  query {
    facebookConnect {
      isAvailable
    }
    wechatConnect {
      isAvailable
    }
  }
`;
export const useExtendedConnect = () => {
  const [isFacebookConnectAvailable, setIsFacebookConnectAvailable] = useState(false);
  const [isWechatConnectAvailable, setIsWechatConnectAvailable] = useState(false);
  const { data, isLoading } = useGQL({
    query,
    queryOptions: {
      requestName: CORE_GET_FACEBOOK_CONNECT_CONFIG,
    },
    cache: true,
  });
  useEffect(() => {
    setIsFacebookConnectAvailable(!!data?.facebookConnect?.isAvailable);
    setIsWechatConnectAvailable(!!data?.wechatConnect?.isAvailable);
  }, [isLoading]);
  return {
    isFacebookConnectAvailable,
    isWechatConnectAvailable,
  };
};
